module.exports = __webpack_public_path__ + "img/MaidAufDemFelsen.2cb2f41d.svg";